/* eslint no-param-reassign: "error" */
import {
  createSlice,
} from '@reduxjs/toolkit';

import type { DeleteOutputType, EntitySubscribeType } from '@/infra/appsync';
import type {
  MealJson,
} from '@/types/domain/meal/entities/mealEntity';
import type { MealStateType } from '@/types/domain/meal/redux';
import type {
  PayloadAction,
} from '@reduxjs/toolkit';

import { service } from '@/share';

const initialState: MealStateType = {
  mealList: [],
  nextToken: null,
};

/**
 * 食事Slice
 */
export const mealSlice = createSlice({
  name: 'meal',
  initialState,
  reducers: {
    /** 食事リストをセットする */
    setMealList:
      (state, action: PayloadAction<{
        nextToken: string,
        items: MealJson[],
      }>) => {
        state.mealList = action.payload.items;
        state.nextToken = action.payload.nextToken;
      },
    /** 食事ストア作成 */
    createMealStore: (state, action: PayloadAction<EntitySubscribeType>) => {
      state.mealList = service.meal.createMealStore(
        state.mealList,
        action.payload,
        undefined,
      );
    },
    /** 食事ストア更新 */
    updateMealStore: (state, action: PayloadAction<EntitySubscribeType>) => {
      state.mealList = service.meal.updateMealStore(
        state.mealList,
        action.payload,
      );
    },
    /** 食事ストア削除 */
    deleteMealStore: (
      state,
      action: PayloadAction<DeleteOutputType>,
    ) => {
      state.mealList = service.meal.deleteMealStore(
        state.mealList,
        action.payload,
      );
    },
  },
});

export default mealSlice.reducer;
